// File generated by MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
import { BaseEntityDto, BaseEntityDtoFormGroup } from './BaseEntityDto';
import { AddressDto } from './AddressDto';
import { IdDocumentDto } from './IdDocumentDto';
import { PersonType } from '../enums/PersonType';

export class PersonDto extends BaseEntityDto {
  addressId: string | null = null;
  address: AddressDto;
  email: string = '';
  fullName: string = '';
  idDocumentId: string = '';
  idDocument: IdDocumentDto;
  isExemptFromOriginDeclaration: boolean = false;
  type: PersonType;
}

export interface PersonDtoFormGroup extends BaseEntityDtoFormGroup {
  addressId?: any;
  address?: any;
  email?: any;
  fullName?: any;
  idDocumentId?: any;
  idDocument?: any;
  isExemptFromOriginDeclaration?: any;
  type?: any;
}
